import { useRef } from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonItem,
  IonList,
  IonModal,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { Asterisk, Badge, Colors, fontMedium, Icon } from "swing-components";

import { translate } from "~utils";

type TimeToAcceptProps = {
  value: number | string | undefined;
  choices: (number | string)[];
  onChange: (v: number | string) => void;
};

export function TimeToAccept(props: TimeToAcceptProps) {
  const { value, choices, onChange } = props;

  const displayValue =
    typeof value === "number"
      ? translate("TIME_TO_ACCEPT_VALUE", { hours: value })
      : typeof value === "string"
        ? translate("TIME_TO_ACCEPT_ONLY_SELECTED_SUBS_VALUE")
        : undefined;

  return (
    <>
      <TimeToAcceptModal trigger="modal" value={value} choices={choices} onChange={onChange} />
      <button id="modal" css={{ width: "100%", display: "flex", alignItems: "center" }}>
        {/* Label and Value */}
        <div>
          <p css={{ margin: 0, display: "inline-block", fontWeight: 500 }}>
            {translate("TIME_TO_ACCEPT_LABEL")}
          </p>
          <Asterisk />
          <p css={{ margin: 0 }}>{displayValue}</p>
        </div>

        {/* Modal Trigger */}
        <div css={{ display: "flex", justifyContent: "end", cursor: "pointer", flex: "1 1 0%" }}>
          <div
            css={{
              display: "flex",
              gap: 4,
              alignItems: "center",
            }}
          >
            <Icon name="Chevron Down" />
          </div>
        </div>
      </button>
    </>
  );
}

type TimeToAcceptModalProps = TimeToAcceptProps & {
  trigger: string;
};

function TimeToAcceptModal(props: TimeToAcceptModalProps) {
  const { trigger, value, choices, onChange } = props;

  const modal = useRef<HTMLIonModalElement>(null);
  function onModalClose() {
    modal.current?.dismiss();
  }

  return (
    <IonModal trigger={trigger} ref={modal} backdropDismiss>
      <IonHeader css={{ boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.15)" }}>
        <IonToolbar>
          <IonTitle>{translate("TIME_TO_ACCEPT_MODAL_HEADER")}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onModalClose} strong>
              {translate("LABEL_CLOSE")}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <p css={{ ...fontMedium({ fontWeight: 600 }), margin: "24px 16px" }}>
          {translate("TIME_TO_ACCEPT_MODAL_DESCRIPTION")}
        </p>
        <IonList css={{ backgroundColor: Colors.white200, padding: "16px 0" }}>
          <IonRadioGroup value={value} onIonChange={(e) => onChange(e.target.value)}>
            {choices.map((timeChoice, idx) => (
              <IonItem key={idx}>
                <IonRadio value={timeChoice} justify="start" labelPlacement="end">
                  <div css={{ display: "flex", flexDirection: "column" }}>
                    {/* If the choice is 15 minutes, then show a RECOMMENDED chip */}
                    {timeChoice === 0.25 && <Badge status="success" text="Recommended" />}
                    {typeof timeChoice === "number"
                      ? translate("TIME_TO_ACCEPT_VALUE", { hours: timeChoice })
                      : translate("TIME_TO_ACCEPT_ONLY_SELECTED_SUBS_VALUE")}
                  </div>
                </IonRadio>
              </IonItem>
            ))}
          </IonRadioGroup>
        </IonList>
      </IonContent>
    </IonModal>
  );
}
